import React from 'react'
import useImportDB from '../../hooks/useImportDB'
import './ImportExport.css';

function buttonText (status, progress) {
  if (status === 'IN-PROGRESS') {
    return `Importing... ${progress}`
  }

  if (status === 'OK') {
    return 'Import successful!'
  }

  if (status === 'FAIL') {
    return 'Import error :('
  }

  return 'Import'
}

function Import () {
  const { state, handleImport, fileUploadRef } = useImportDB()

  if (state.status === 'FAIL') {
    console.log(state.error)
  }

  return (
    <div className="import-export">
      <h3>Import database</h3>
      <p>Upload the JSON file exported above to import it into your browser's database.</p>
      <form onSubmit={handleImport}>
        <input type="file" name="file" accept="application/json" ref={fileUploadRef} />
        <button
          type="submit"
          disabled={state.status === 'IN-PROGRESS'}
        >
          {buttonText(state.status, state.progress)}
        </button>
        {state.status === 'FAIL' && <p className="error">{state.error.message}</p>}
      </form>
    </div>
  )
}

export default Import
